module.exports = new __parcel__URL__("FDP.d1d6dc12.png").toString();